export const AuthState = {
  initialization: 'initialization',
  guest: 'guest',
  producer: 'producer',
  stakeholder: 'stakeholder',
  insuranceAgent: 'insuranceAgent',
  insuranceAgentAdministrator: 'insuranceAgentAdministrator',
  globalAdministrator: 'globalAdministrator',
  expired: 'expired'
} as const;

export type AuthStateType = (typeof AuthState)[keyof typeof AuthState];

export const isProducerLike = (authState: AuthStateType): boolean =>
  authState === AuthState.producer || authState === AuthState.stakeholder;
